
  import Vue from 'vue'
  import Component from 'vue-class-component';
  import ShareButton from '@/components/Shared/buttons/ShareButton.vue';
  import {challengesState} from '@/utils/store-acessor';
  import ChallengeFollowButton from './ChallengeFollowButton.vue';
  import {Prop} from 'vue-property-decorator';
  import {ChallengeModel} from '@/models/challenge.model';
  import {nFormatter} from '@/utils/utils';

  @Component({
    components: {
      ChallengeFollowButton,
      ShareButton
    }
  })
  export default class ChallengeToolbar extends Vue {
    @Prop({required: true}) challenge!: ChallengeModel;
    visitors: number | null = null;

    mounted() {
      if (this.challenge?.id) {
        challengesState.registerAndGetVisitors(this.challenge.id)
          .then(({total}) => this.visitors = total);
      }
    }

    formatCounter(value: number) {
      return nFormatter(value);
    }
  }
